export default "__VITE_ASSET__BboTlsDv__"